import { gql } from '@apollo/client';

export const UNPUBLISH_ESTATE = gql`
  mutation UnpublishEstate($estateId: Int!, $unpublishReason: String!) {
    unpublishEstate(estateId: $estateId, unpublishReason: $unpublishReason)
  }
`;
